module.exports = __webpack_public_path__ + "img/Jerry Carl Jr.ad477c53.jpg";